function premiumFeatures() {
  const premiumMenuClose = document.querySelectorAll('.menu-close__btn');
  const premiumFeatureLinks = document.querySelectorAll('.premium-feature__link');
  const body = document.querySelector('body');
  const premiumAccountHeading = document.querySelector('.premium-login__title');
  const logoutBtn = document.querySelectorAll('.logout__link');

  const isHomePage = window.location.pathname === '/';
  const isLoggedIn = body.dataset.customerLoggedIn === 'true';
  
  if (sessionStorage.getItem('isPremiumActive') === 'true') {
    body.classList.add('logged-in__users');
  } else {
    body.classList.remove('logged-in__users');
  }

  premiumMenuClose.forEach(btn => {
    btn.addEventListener('click', () => {
      sessionStorage.removeItem('isPremiumActive');
      // localStorage.removeItem('isPremiumActive');
      body.classList.remove('logged-in__users');

      if (!isHomePage) {
        window.location.href = '/';
      }
    });
  });
  logoutBtn.forEach(btn => {
    if (btn) {
      btn.addEventListener('click', () => {
        sessionStorage.removeItem('isPremiumActive');
      });
    }
  });

  premiumFeatureLinks.forEach(link => {
    link.addEventListener('click', (event) => {
      if (isLoggedIn) {
        event.preventDefault();

        sessionStorage.setItem('isPremiumActive', 'true');
        sessionStorage.removeItem('isPremiumClick');
        // localStorage.setItem('isPremiumActive', 'true');
        body.classList.add('logged-in__users');

        if (premiumAccountHeading) {
          premiumAccountHeading.classList.remove('hidden');
        }

        const targetURL = link.getAttribute('href');
        if (targetURL) {
          window.location.href = targetURL;
        }
      } else {
        sessionStorage.setItem('isPremiumClick', 'true');
      }
    });
  });
}
function premiumLinks() {
  document.addEventListener('click', function(event) {
    const isLink = event.target.closest('a');
    const isPremiumLink = event.target.closest('.premium-feature__link');
  
    if (isLink && !isPremiumLink) {
      sessionStorage.removeItem('isPremiumClick');
    }
  });
}
document.addEventListener('DOMContentLoaded', () => {
  premiumFeatures();
  premiumLinks();
});
